/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  AutonomousSubArt,
  AutonomousSubArtInterface,
} from "../AutonomousSubArt";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "parentAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "balanceOfParent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "balanceOfRoot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "balanceOfToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "currentPriceToMint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "getForkBasePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "getForkPriceIncrementInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "historicalImageAt",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "layerIndex",
        type: "uint256",
      },
    ],
    name: "historicalImageAtLayerIndex",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "imageForFork",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "isForkActivated",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "layerIndex",
        type: "uint256",
      },
    ],
    name: "layerAt",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "creator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "funded",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawIndex",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct AutonomousSubArt.Layer",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "layerCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "layer",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "basePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "priceIncrementInterval",
        type: "uint256",
      },
    ],
    name: "setForkConfiguration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "totalForkFunded",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalFunded",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "parentId",
        type: "uint256",
      },
    ],
    name: "withdrawForParent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawForRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "withdrawForToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162003b4438038062003b44833981016040819052620000349162000259565b8251839083906200004d90600090602085019062000108565b5080516200006390600190602084019062000108565b505050620000806200007a620000b260201b60201c565b620000b6565b600d80546001600160a01b0319166001600160a01b039290921691909117905550506000600e819055600f5562000335565b3390565b600a80546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b8280546200011690620002e2565b90600052602060002090601f0160209004810192826200013a576000855562000185565b82601f106200015557805160ff191683800117855562000185565b8280016001018555821562000185579182015b828111156200018557825182559160200191906001019062000168565b506200019392915062000197565b5090565b5b8082111562000193576000815560010162000198565b600082601f830112620001bf578081fd5b81516001600160401b0380821115620001dc57620001dc6200031f565b6040516020601f8401601f19168201810183811183821017156200020457620002046200031f565b60405283825285840181018710156200021b578485fd5b8492505b838310156200023e57858301810151828401820152918201916200021f565b838311156200024f57848185840101525b5095945050505050565b6000806000606084860312156200026e578283fd5b83516001600160401b038082111562000285578485fd5b6200029387838801620001ae565b94506020860151915080821115620002a9578384fd5b50620002b886828701620001ae565b604086015190935090506001600160a01b0381168114620002d7578182fd5b809150509250925092565b600281046001821680620002f757607f821691505b602082108114156200031957634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052604160045260246000fd5b6137ff80620003456000396000f3fe6080604052600436106102a05760003560e01c80638da5cb5b1161016e578063cee61d37116100cb578063e985e9c51161007f578063f2fde38b11610064578063f2fde38b14610701578063f3cd9cf614610721578063f7eb5b9e14610741576102a0565b8063e985e9c5146106c1578063efd32692146106e1576102a0565b8063df5aed89116100b0578063df5aed891461066c578063e3ae769214610681578063e87ce156146106a1576102a0565b8063cee61d3714610639578063db7fd40814610659576102a0565b8063a3ed4c3011610122578063b88d4fde11610107578063b88d4fde146105d9578063c87b56dd146105f9578063cd7e7cfa14610619576102a0565b8063a3ed4c3014610597578063ad044f49146105c4576102a0565b80639f181b5e116101535780639f181b5e146105425780639fa5819014610557578063a22cb46514610577576102a0565b80638da5cb5b1461051857806395d89b411461052d576102a0565b806342842e0e1161021c5780636f9a5640116101d0578063715018a6116101b5578063715018a6146104c35780637d9a1143146104d85780637ff295b3146104f8576102a0565b80636f9a56401461048e57806370a08231146104a3576102a0565b80635f380fbc116102015780635f380fbc1461042e5780636352211e1461044e5780636953e3211461046e576102a0565b806342842e0e146103ee5780634f6ccce71461040e576102a0565b8063095ea7b3116102735780631bae412a116102585780631bae412a1461038e57806323b872dd146103ae5780632f745c59146103ce576102a0565b8063095ea7b31461035757806318160ddd14610379576102a0565b806301ffc9a7146102a557806306fdde03146102db5780630760a542146102fd578063081812fc1461032a575b600080fd5b3480156102b157600080fd5b506102c56102c0366004612858565b610761565b6040516102d29190612db4565b60405180910390f35b3480156102e757600080fd5b506102f06107a7565b6040516102d29190612dbf565b34801561030957600080fd5b5061031d6103183660046128fa565b610839565b6040516102d29190612dd2565b34801561033657600080fd5b5061034a6103453660046128fa565b610856565b6040516102d29190612d64565b34801561036357600080fd5b5061037761037236600461282d565b6108a2565b005b34801561038557600080fd5b5061031d61093a565b34801561039a57600080fd5b506103776103a93660046128fa565b610940565b3480156103ba57600080fd5b506103776103c9366004612752565b610a3e565b3480156103da57600080fd5b5061031d6103e936600461282d565b610a76565b3480156103fa57600080fd5b50610377610409366004612752565b610ac8565b34801561041a57600080fd5b5061031d6104293660046128fa565b610ae3565b34801561043a57600080fd5b50610377610449366004612990565b610b3e565b34801561045a57600080fd5b5061034a6104693660046128fa565b610c4a565b34801561047a57600080fd5b506102f061048936600461296f565b610c7f565b34801561049a57600080fd5b5061031d610ceb565b3480156104af57600080fd5b5061031d6104be3660046126e2565b610cf1565b3480156104cf57600080fd5b50610377610d35565b3480156104e457600080fd5b506103776104f33660046128fa565b610d80565b34801561050457600080fd5b506102c56105133660046128fa565b610e64565b34801561052457600080fd5b5061034a610f0d565b34801561053957600080fd5b506102f0610f1c565b34801561054e57600080fd5b5061031d610f2b565b34801561056357600080fd5b506102f06105723660046128fa565b610f31565b34801561058357600080fd5b506103776105923660046127fc565b610f77565b3480156105a357600080fd5b506105b76105b236600461296f565b611045565b6040516102d29190613570565b3480156105d057600080fd5b5061031d611188565b3480156105e557600080fd5b506103776105f4366004612792565b61118e565b34801561060557600080fd5b506102f06106143660046128fa565b6111c7565b34801561062557600080fd5b5061031d6106343660046128fa565b6112a5565b34801561064557600080fd5b506102f06106543660046128fa565b6112ba565b61031d61066736600461292a565b6112ea565b34801561067857600080fd5b5061037761153c565b34801561068d57600080fd5b5061031d61069c3660046128fa565b61161f565b3480156106ad57600080fd5b5061031d6106bc3660046128fa565b611642565b3480156106cd57600080fd5b506102c56106dc36600461271a565b611662565b3480156106ed57600080fd5b5061031d6106fc3660046128fa565b611690565b34801561070d57600080fd5b5061037761071c3660046126e2565b611728565b34801561072d57600080fd5b5061031d61073c3660046128fa565b611799565b34801561074d57600080fd5b5061031d61075c3660046128fa565b6117e6565b60006001600160e01b031982167f780e9d6300000000000000000000000000000000000000000000000000000000148061079f575061079f826117fb565b90505b919050565b6060600080546107b6906136b2565b80601f01602080910402602001604051908101604052809291908181526020018280546107e2906136b2565b801561082f5780601f106108045761010080835404028352916020019161082f565b820191906000526020600020905b81548152906001019060200180831161081257829003601f168201915b5050505050905090565b6000818152600b602052604081206002015461079f90839061186d565b600061086182611908565b6108865760405162461bcd60e51b815260040161087d90613255565b60405180910390fd5b506000908152600460205260409020546001600160a01b031690565b60006108ad82610c4a565b9050806001600160a01b0316836001600160a01b031614156108e15760405162461bcd60e51b815260040161087d906133c7565b806001600160a01b03166108f3611925565b6001600160a01b0316148061090f575061090f816106dc611925565b61092b5760405162461bcd60e51b815260040161087d90613109565b6109358383611929565b505050565b60085490565b600d546040516331a9108f60e11b815233916001600160a01b031690636352211e90610970908590600401612dd2565b60206040518083038186803b15801561098857600080fd5b505afa15801561099c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109c091906126fe565b6001600160a01b0316146109e65760405162461bcd60e51b815260040161087d90612e12565b60006109f182610839565b6000838152600b602052604080822060048101546002820155905192935091339184156108fc02918591818181858888f19350505050158015610a38573d6000803e3d6000fd5b50505050565b610a4f610a49611925565b82611997565b610a6b5760405162461bcd60e51b815260040161087d90613481565b610935838383611a1c565b6000610a8183610cf1565b8210610a9f5760405162461bcd60e51b815260040161087d90612e47565b506001600160a01b03919091166000908152600660209081526040808320938352929052205490565b6109358383836040518060200160405280600081525061118e565b6000610aed61093a565b8210610b0b5760405162461bcd60e51b815260040161087d906134de565b60088281548110610b2c57634e487b7160e01b600052603260045260246000fd5b90600052602060002001549050919050565b600d546040516331a9108f60e11b815233916001600160a01b031690636352211e90610b6e908790600401612dd2565b60206040518083038186803b158015610b8657600080fd5b505afa158015610b9a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bbe91906126fe565b6001600160a01b031614610be45760405162461bcd60e51b815260040161087d90613424565b60008211610c045760405162461bcd60e51b815260040161087d906130d2565b6000838152600b6020526040902054821015610c325760405162461bcd60e51b815260040161087d90613390565b6000928352600b602052604090922090815560010155565b6000818152600260205260408120546001600160a01b03168061079f5760405162461bcd60e51b815260040161087d906131c3565b6000828152600b602052604081206004018054606092919084908110610cb557634e487b7160e01b600052603260045260246000fd5b60009182526020909120600690910201546001600160a01b03161415610cda57600080fd5b610ce48383611b49565b9392505050565b600f5490565b60006001600160a01b038216610d195760405162461bcd60e51b815260040161087d90613166565b506001600160a01b031660009081526003602052604090205490565b610d3d611925565b6001600160a01b0316610d4e610f0d565b6001600160a01b031614610d745760405162461bcd60e51b815260040161087d906132a1565b610d7e6000611b84565b565b33610d8a82610c4a565b6001600160a01b031614610db05760405162461bcd60e51b815260040161087d90612e12565b6000610dbb82611690565b6000838152600c6020908152604080832080548452600b909252822060018201546004909101805494955091938110610e0457634e487b7160e01b600052603260045260246000fd5b6000918252602080832085548452600b909152604080842060040154600360069094029092019283019190915551909250339185156108fc02918691818181858888f19350505050158015610e5d573d6000803e3d6000fd5b5050505050565b600080600d60009054906101000a90046001600160a01b03166001600160a01b03166356e7f6c76040518163ffffffff1660e01b815260040160206040518083038186803b158015610eb557600080fd5b505afa158015610ec9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610eed9190612912565b90508281118015610ce45750600a610f05848361366f565b119392505050565b600a546001600160a01b031690565b6060600180546107b6906136b2565b600e5490565b6060610f3c82611908565b610f585760405162461bcd60e51b815260040161087d90612ddb565b6000828152600c6020526040902080546001820154610ce49190611b49565b610f7f611925565b6001600160a01b0316826001600160a01b03161415610fb05760405162461bcd60e51b815260040161087d9061304f565b8060056000610fbd611925565b6001600160a01b03908116825260208083019390935260409182016000908120918716808252919093529120805460ff191692151592909217909155611001611925565b6001600160a01b03167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31836040516110399190612db4565b60405180910390a35050565b61104d6125b9565b6000838152600b6020526040902060040180548390811061107e57634e487b7160e01b600052603260045260246000fd5b90600052602060002090600602016040518060c00160405290816000820160009054906101000a90046001600160a01b03166001600160a01b03166001600160a01b03168152602001600182015481526020016002820154815260200160038201548152602001600482015481526020016005820180546110fe906136b2565b80601f016020809104026020016040519081016040528092919081815260200182805461112a906136b2565b80156111775780601f1061114c57610100808354040283529160200191611177565b820191906000526020600020905b81548152906001019060200180831161115a57829003601f168201915b505050505081525050905092915050565b60105490565b61119f611199611925565b83611997565b6111bb5760405162461bcd60e51b815260040161087d90613481565b610a3884848484611bd6565b60606111d282611908565b6111ee5760405162461bcd60e51b815260040161087d90613333565b6000828152600c602090815260408083208054808552600b909352908320600481015491939092909161122d91906112289060019061366f565b611b49565b905060006112756112418560000154611c09565b61124e8660010154611c09565b8460405160200161126193929190612b38565b604051602081830303815290604052611d58565b905060008160405160200161128a9190612c22565b60408051808303601f19018152919052979650505050505050565b6000908152600b602052604090206003015490565b6000818152600b6020526040902060040154606090610ce483826112df576000611228565b61122860018461366f565b60006112f583610e64565b6113115760405162461bcd60e51b815260040161087d90612ea4565b3461131b84611799565b11156113395760405162461bcd60e51b815260040161087d9061353b565b600d546040517f64d265df0000000000000000000000000000000000000000000000000000000081526001600160a01b03909116906364d265df90611382908590600401612dbf565b60006040518083038186803b15801561139a57600080fd5b505afa1580156113ae573d6000803e3d6000fd5b5050506000848152600b60209081526040808320600e5460048083018054855160c0810187523381524281890190815234978201978852606082018381526080830187815260a084018f815260018087018855968d529b8b902084516006870290910180546001600160a01b0319166001600160a01b039092169190911781559251958301959095559751600282015596516003880155915192860192909255955180519397509195909490939261146c92600585019201906125f8565b505050348360030160008282546114839190613624565b909155505060408051808201825287815260208082018481526000868152600c909252928120915182559151600191820155600e8054919290916114c8908490613624565b909155506114d99050816001613624565b6114e4906001613624565b6114ef906001613624565b6114f9903461363c565b600f600082825461150a9190613624565b9250508190555034601060008282546115239190613624565b9091555061153390503383611f04565b50949350505050565b600d546040516331a9108f60e11b815233916001600160a01b031690636352211e9061156d90600090600401612dd2565b60206040518083038186803b15801561158557600080fd5b505afa158015611599573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115bd91906126fe565b6001600160a01b0316146115e35760405162461bcd60e51b815260040161087d90612e12565b600f80546000918290556040519091339183156108fc0291849190818181858888f1935050505015801561161b573d6000803e3d6000fd5b5050565b6000818152600b60205260408120548061079f5750665543df729c000092915050565b6000818152600b60205260408120600101548061079f5750600a92915050565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205460ff1690565b600061169b82611908565b6116b75760405162461bcd60e51b815260040161087d90612ddb565b6000828152600c602090815260408083208054600190910154818552600b90935290832060040180549193918390811061170157634e487b7160e01b600052603260045260246000fd5b906000526020600020906006020160030154905061171f838261186d565b95945050505050565b611730611925565b6001600160a01b0316611741610f0d565b6001600160a01b0316146117675760405162461bcd60e51b815260040161087d906132a1565b6001600160a01b03811661178d5760405162461bcd60e51b815260040161087d90612f5e565b61179681611b84565b50565b6000806117a58361161f565b905060006117b284611642565b6000858152600b60205260409020600401549091506117d1828261363c565b6117dc906001613624565b61171f9084613650565b6000908152600b602052604090206004015490565b60006001600160e01b031982167f80ac58cd00000000000000000000000000000000000000000000000000000000148061185e57506001600160e01b031982167f5b5e139f00000000000000000000000000000000000000000000000000000000145b8061079f575061079f82611f1e565b6000828152600b6020526040812081835b600483015481101561153357611895816001613624565b6118a0906001613624565b6118ab906001613624565b8360040182815481106118ce57634e487b7160e01b600052603260045260246000fd5b9060005260206000209060060201600201546118ea919061363c565b6118f49083613624565b915080611900816136ed565b91505061187e565b6000908152600260205260409020546001600160a01b0316151590565b3390565b600081815260046020526040902080546001600160a01b0319166001600160a01b038416908117909155819061195e82610c4a565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b60006119a282611908565b6119be5760405162461bcd60e51b815260040161087d90613086565b60006119c983610c4a565b9050806001600160a01b0316846001600160a01b03161480611a045750836001600160a01b03166119f984610856565b6001600160a01b0316145b80611a145750611a148185611662565b949350505050565b826001600160a01b0316611a2f82610c4a565b6001600160a01b031614611a555760405162461bcd60e51b815260040161087d906132d6565b6001600160a01b038216611a7b5760405162461bcd60e51b815260040161087d90612ff2565b611a86838383611f50565b611a91600082611929565b6001600160a01b0383166000908152600360205260408120805460019290611aba90849061366f565b90915550506001600160a01b0382166000908152600360205260408120805460019290611ae8908490613624565b909155505060008181526002602052604080822080546001600160a01b0319166001600160a01b0386811691821790925591518493918716917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b6060611b5d611b588484611fd9565b611d58565b604051602001611b6d9190612d1f565b604051602081830303815290604052905092915050565b600a80546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b611be1848484611a1c565b611bed8484848461216f565b610a385760405162461bcd60e51b815260040161087d90612f01565b606081611c4a575060408051808201909152600181527f300000000000000000000000000000000000000000000000000000000000000060208201526107a2565b8160005b8115611c745780611c5e816136ed565b9150611c6d9050600a8361363c565b9150611c4e565b60008167ffffffffffffffff811115611c9d57634e487b7160e01b600052604160045260246000fd5b6040519080825280601f01601f191660200182016040528015611cc7576020820181803683370190505b5090505b8415611a1457611cdc60018361366f565b9150611ce9600a86613708565b611cf4906030613624565b60f81b818381518110611d1757634e487b7160e01b600052603260045260246000fd5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a905350611d51600a8661363c565b9450611ccb565b6060815160001415611d7957506040805160208101909152600081526107a2565b600060405180606001604052806040815260200161378a6040913990506000600384516002611da89190613624565b611db2919061363c565b611dbd906004613650565b90506000611dcc826020613624565b67ffffffffffffffff811115611df257634e487b7160e01b600052604160045260246000fd5b6040519080825280601f01601f191660200182016040528015611e1c576020820181803683370190505b509050818152600183018586518101602084015b81831015611e88576003830192508251603f8160121c168501518253600182019150603f81600c1c168501518253600182019150603f8160061c168501518253600182019150603f8116850151825350600101611e30565b600389510660018114611ea25760028114611ece57611ef6565b7f3d3d000000000000000000000000000000000000000000000000000000000000600119830152611ef6565b7f3d000000000000000000000000000000000000000000000000000000000000006000198301525b509398975050505050505050565b61161b8282604051806020016040528060008152506122a3565b6001600160e01b031981167f01ffc9a70000000000000000000000000000000000000000000000000000000014919050565b611f5b838383610935565b6001600160a01b038316611f7757611f72816122d6565b611f9a565b816001600160a01b0316836001600160a01b031614611f9a57611f9a838261231a565b6001600160a01b038216611fb657611fb1816123b7565b610935565b826001600160a01b0316826001600160a01b031614610935576109358282612490565b600d546040517f9fa581900000000000000000000000000000000000000000000000000000000081526060916000916001600160a01b0390911690639fa5819090612028908790600401612dd2565b60006040518083038186803b15801561204057600080fd5b505afa158015612054573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261207c9190810190612890565b90506000816040516020016120919190612c67565b604051602081830303815290604052905060005b8481111580156120c557506000868152600b602052604090206004015481105b15612144576000868152600b602052604090206004018054839190839081106120fe57634e487b7160e01b600052603260045260246000fd5b9060005260206000209060060201600501604051602001612120929190612a10565b6040516020818303038152906040529150808061213c906136ed565b9150506120a5565b50806040516020016121569190612af7565b60408051808303601f1901815291905295945050505050565b6000612183846001600160a01b03166124d4565b1561229857836001600160a01b031663150b7a0261219f611925565b8786866040518563ffffffff1660e01b81526004016121c19493929190612d78565b602060405180830381600087803b1580156121db57600080fd5b505af192505050801561220b575060408051601f3d908101601f1916820190925261220891810190612874565b60015b612265573d808015612239576040519150601f19603f3d011682016040523d82523d6000602084013e61223e565b606091505b50805161225d5760405162461bcd60e51b815260040161087d90612f01565b805181602001fd5b6001600160e01b0319167f150b7a0200000000000000000000000000000000000000000000000000000000149050611a14565b506001949350505050565b6122ad83836124da565b6122ba600084848461216f565b6109355760405162461bcd60e51b815260040161087d90612f01565b600880546000838152600960205260408120829055600182018355919091527ff3f7a9fe364faab93b216da50a3214154f22a0a2b415b23a84c8169e8b636ee30155565b6000600161232784610cf1565b612331919061366f565b600083815260076020526040902054909150808214612384576001600160a01b03841660009081526006602090815260408083208584528252808320548484528184208190558352600790915290208190555b5060009182526007602090815260408084208490556001600160a01b039094168352600681528383209183525290812055565b6008546000906123c99060019061366f565b600083815260096020526040812054600880549394509092849081106123ff57634e487b7160e01b600052603260045260246000fd5b90600052602060002001549050806008838154811061242e57634e487b7160e01b600052603260045260246000fd5b600091825260208083209091019290925582815260099091526040808220849055858252812055600880548061247457634e487b7160e01b600052603160045260246000fd5b6001900381819060005260206000200160009055905550505050565b600061249b83610cf1565b6001600160a01b039093166000908152600660209081526040808320868452825280832085905593825260079052919091209190915550565b3b151590565b6001600160a01b0382166125005760405162461bcd60e51b815260040161087d90613220565b61250981611908565b156125265760405162461bcd60e51b815260040161087d90612fbb565b61253260008383611f50565b6001600160a01b038216600090815260036020526040812080546001929061255b908490613624565b909155505060008181526002602052604080822080546001600160a01b0319166001600160a01b03861690811790915590518392907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b6040518060c0016040528060006001600160a01b0316815260200160008152602001600081526020016000815260200160008152602001606081525090565b828054612604906136b2565b90600052602060002090601f016020900481019282612626576000855561266c565b82601f1061263f57805160ff191683800117855561266c565b8280016001018555821561266c579182015b8281111561266c578251825591602001919060010190612651565b5061267892915061267c565b5090565b5b80821115612678576000815560010161267d565b600082601f8301126126a1578081fd5b81356126b46126af826135f0565b6135c6565b8181528460208386010111156126c8578283fd5b816020850160208301379081016020019190915292915050565b6000602082840312156126f3578081fd5b8135610ce48161375e565b60006020828403121561270f578081fd5b8151610ce48161375e565b6000806040838503121561272c578081fd5b82356127378161375e565b915060208301356127478161375e565b809150509250929050565b600080600060608486031215612766578081fd5b83356127718161375e565b925060208401356127818161375e565b929592945050506040919091013590565b600080600080608085870312156127a7578081fd5b84356127b28161375e565b935060208501356127c28161375e565b925060408501359150606085013567ffffffffffffffff8111156127e4578182fd5b6127f087828801612691565b91505092959194509250565b6000806040838503121561280e578182fd5b82356128198161375e565b915060208301358015158114612747578182fd5b6000806040838503121561283f578182fd5b823561284a8161375e565b946020939093013593505050565b600060208284031215612869578081fd5b8135610ce481613773565b600060208284031215612885578081fd5b8151610ce481613773565b6000602082840312156128a1578081fd5b815167ffffffffffffffff8111156128b7578182fd5b8201601f810184136128c7578182fd5b80516128d56126af826135f0565b8181528560208385010111156128e9578384fd5b61171f826020830160208601613686565b60006020828403121561290b578081fd5b5035919050565b600060208284031215612923578081fd5b5051919050565b6000806040838503121561293c578182fd5b82359150602083013567ffffffffffffffff811115612959578182fd5b61296585828601612691565b9150509250929050565b60008060408385031215612981578081fd5b50508035926020909101359150565b6000806000606084860312156129a4578081fd5b505081359360208301359350604090920135919050565b600081518084526129d3816020860160208601613686565b601f01601f19169290920160200192915050565b7f3c2f673e00000000000000000000000000000000000000000000000000000000815260040190565b600083516020612a238285838901613686565b7f3c673e00000000000000000000000000000000000000000000000000000000009184019182528454600390849060028104600180831680612a6657607f831692505b868310811415612a8457634e487b7160e01b89526022600452602489fd5b808015612a985760018114612aad57612add565b60ff1985168988015283890187019550612add565b612ab68c613618565b8a5b85811015612ad35781548b82018a0152908401908901612ab8565b505086848a010195505b5050505050612aeb816129e7565b98975050505050505050565b60008251612b09818460208701613686565b7f3c2f7376673e0000000000000000000000000000000000000000000000000000920191825250600601919050565b60007f7b226e616d65223a224175746f6e6f6d6f75732053756220417274202300000082528451612b7081601d850160208901613686565b7f2e00000000000000000000000000000000000000000000000000000000000000601d918401918201528451612bad81601e840160208901613686565b7f222c22696d616765223a22000000000000000000000000000000000000000000601e92909101918201528351612beb816029840160208801613686565b7f227d00000000000000000000000000000000000000000000000000000000000060299290910191820152602b0195945050505050565b60007f646174613a6170706c69636174696f6e2f6a736f6e3b6261736536342c00000082528251612c5a81601d850160208701613686565b91909101601d0192915050565b60007f3c7376672076696577426f783d2230203020353030203530302220786d6c6e7382527f3d22687474703a2f2f7777772e77332e6f72672f323030302f7376672220737460208301527f796c653d226261636b67726f756e642d696d6167653a75726c2800000000000060408301528251612ceb81605a850160208701613686565b7f29223e0000000000000000000000000000000000000000000000000000000000605a939091019283015250605d01919050565b60007f646174613a696d6167652f7376672b786d6c3b6261736536342c00000000000082528251612d5781601a850160208701613686565b91909101601a0192915050565b6001600160a01b0391909116815260200190565b60006001600160a01b03808716835280861660208401525083604083015260806060830152612daa60808301846129bb565b9695505050505050565b901515815260200190565b600060208252610ce460208301846129bb565b90815260200190565b6020808252601b908201527f517565727920666f72206e6f6e6578697374656e7420746f6b656e0000000000604082015260600190565b6020808252818101527f556e617574686f72697a656420617474656d707420746f207769746864726177604082015260600190565b6020808252602b908201527f455243373231456e756d657261626c653a206f776e657220696e646578206f7560408201527f74206f6620626f756e6473000000000000000000000000000000000000000000606082015260800190565b60208082526021908201527f496e76616c696420706172656e742c206e6f742079657420616374697661746560408201527f6400000000000000000000000000000000000000000000000000000000000000606082015260800190565b60208082526032908201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527f63656976657220696d706c656d656e7465720000000000000000000000000000606082015260800190565b60208082526026908201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160408201527f6464726573730000000000000000000000000000000000000000000000000000606082015260800190565b6020808252601c908201527f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000604082015260600190565b60208082526024908201527f4552433732313a207472616e7366657220746f20746865207a65726f2061646460408201527f7265737300000000000000000000000000000000000000000000000000000000606082015260800190565b60208082526019908201527f4552433732313a20617070726f766520746f2063616c6c657200000000000000604082015260600190565b6020808252602c908201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860408201526b34b9ba32b73a103a37b5b2b760a11b606082015260800190565b60208082526017908201527f426173652070726963652063616e206e6f742062652030000000000000000000604082015260600190565b60208082526038908201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760408201527f6e6572206e6f7220617070726f76656420666f7220616c6c0000000000000000606082015260800190565b6020808252602a908201527f4552433732313a2062616c616e636520717565727920666f7220746865207a6560408201527f726f206164647265737300000000000000000000000000000000000000000000606082015260800190565b60208082526029908201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460408201527f656e7420746f6b656e0000000000000000000000000000000000000000000000606082015260800190565b6020808252818101527f4552433732313a206d696e7420746f20746865207a65726f2061646472657373604082015260600190565b6020808252602c908201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860408201526b34b9ba32b73a103a37b5b2b760a11b606082015260800190565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b60208082526029908201527f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960408201527f73206e6f74206f776e0000000000000000000000000000000000000000000000606082015260800190565b6020808252602f908201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60408201527f6e6578697374656e7420746f6b656e0000000000000000000000000000000000606082015260800190565b6020808252601c908201527f426173652070726963652063616e206f6e6c7920696e63726561736500000000604082015260600190565b60208082526021908201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560408201527f7200000000000000000000000000000000000000000000000000000000000000606082015260800190565b60208082526026908201527f556e617574686f72697a656420617474656d707420746f20636f6e666967757260408201527f6520666f726b0000000000000000000000000000000000000000000000000000606082015260800190565b60208082526031908201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60408201527f776e6572206e6f7220617070726f766564000000000000000000000000000000606082015260800190565b6020808252602c908201527f455243373231456e756d657261626c653a20676c6f62616c20696e646578206f60408201527f7574206f6620626f756e64730000000000000000000000000000000000000000606082015260800190565b6020808252818101527f4574682076616c75652073656e74206973206e6f742073756666696369656e74604082015260600190565b6000602082526001600160a01b038351166020830152602083015160408301526040830151606083015260608301516080830152608083015160a083015260a083015160c080840152611a1460e08401826129bb565b60405181810167ffffffffffffffff811182821017156135e8576135e8613748565b604052919050565b600067ffffffffffffffff82111561360a5761360a613748565b50601f01601f191660200190565b60009081526020902090565b600082198211156136375761363761371c565b500190565b60008261364b5761364b613732565b500490565b600081600019048311821515161561366a5761366a61371c565b500290565b6000828210156136815761368161371c565b500390565b60005b838110156136a1578181015183820152602001613689565b83811115610a385750506000910152565b6002810460018216806136c657607f821691505b602082108114156136e757634e487b7160e01b600052602260045260246000fd5b50919050565b60006000198214156137015761370161371c565b5060010190565b60008261371757613717613732565b500690565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052601260045260246000fd5b634e487b7160e01b600052604160045260246000fd5b6001600160a01b038116811461179657600080fd5b6001600160e01b03198116811461179657600080fdfe4142434445464748494a4b4c4d4e4f505152535455565758595a6162636465666768696a6b6c6d6e6f707172737475767778797a303132333435363738392b2fa2646970667358221220e4229ed344ded3c00bc04202a28c8b1f4199953f74901f3e7cfc4a57fb6f78c264736f6c63430008000033";

type AutonomousSubArtConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AutonomousSubArtConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AutonomousSubArt__factory extends ContractFactory {
  constructor(...args: AutonomousSubArtConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    name: string,
    symbol: string,
    parentAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AutonomousSubArt> {
    return super.deploy(
      name,
      symbol,
      parentAddress,
      overrides || {}
    ) as Promise<AutonomousSubArt>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    parentAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      parentAddress,
      overrides || {}
    );
  }
  attach(address: string): AutonomousSubArt {
    return super.attach(address) as AutonomousSubArt;
  }
  connect(signer: Signer): AutonomousSubArt__factory {
    return super.connect(signer) as AutonomousSubArt__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AutonomousSubArtInterface {
    return new utils.Interface(_abi) as AutonomousSubArtInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AutonomousSubArt {
    return new Contract(address, _abi, signerOrProvider) as AutonomousSubArt;
  }
}
